import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const Globals = require('../../../../app/globals');
import Navigator from '../../Navigator';
import withSignInStoreState from '../DataHOCs/WithSignInStoreState';

const propTypes = {
    history: PropTypes.object.isRequired,
    signInStoreState: PropTypes.shape({
        initializedLocal: PropTypes.bool.isRequired,
        userInfo: PropTypes.shape({
            local_role_type: PropTypes.oneOf(Object.values(Globals.users.local_role_type)).isRequired
        }),
    }).isRequired,
};
const defaultProps = {};

class DashboardHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.attemptTransitionRoleRootView = this.attemptTransitionRoleRootView.bind(this);
    }

    componentDidMount() {
        this.attemptTransitionRoleRootView();
    }

    componentDidUpdate(prevProps, prevState) {
        this.attemptTransitionRoleRootView();
    }

    attemptTransitionRoleRootView() {
        if (this.props.signInStoreState.initializedLocal) {
            switch (this.props.signInStoreState.userInfo.local_role_type) {
                case Globals.users.local_role_type.STUDENT: {
                    Navigator.goToDashboardStudent(this.props.history, { replace: true });
                    break;
                }
                case Globals.users.local_role_type.AUTHOR: {
                    Navigator.goToDashboardAuthor(this.props.history, { replace: true });
                    break;
                }
                default: {
                    console.warn('Undefined or unhandled local_role_type:', this.props.signInStoreState.userInfo.local_role_type);
                    Navigator.goToDashboardAuthor(this.props.history, { replace: true }); // go somewhere...
                    break;
                }
                
            }
        }
    }

    render() {
        return null;
    }
}

DashboardHome.propTypes = propTypes;
DashboardHome.defaultProps = defaultProps;

export default withRouter(withSignInStoreState(DashboardHome));